export const isIOSApp = typeof window !== "undefined" && window.navigator.userAgent === "cashorbit/iOS"